import {Component, EventEmitter, Input, OnChanges, Output, SimpleChanges} from '@angular/core';
import {SubscriberComponent} from '../subscriber.component';
import {TabReport} from '../../_models/report/tab-report';
import {Column} from '../../_models/report/column';
import {DashboardWidget} from '../../_models/dashboard-widget';
import {ColumnFormatterService} from '../../_services/column-formatter.service';
import {Filter} from '../../_models/report/filter';
import {FilterValue} from '../../_models/report/filter-value';

@Component({
    template: ''
})
export abstract class BaseWidgetComponent extends SubscriberComponent implements OnChanges {
    @Input() widget: DashboardWidget;
    @Input() tabReport: TabReport;
    @Input() startDate: string;
    @Input() endDate: string;
    @Input() selectedPickupLocations: number[];

    @Output() dataLoading = new EventEmitter();
    @Output() dataReady = new EventEmitter();
    loading = true;
    error = false;

    abstract refresh();

    protected constructor(
        protected columnFormatterService: ColumnFormatterService
    ) {
        super();
    }

    ngOnChanges(changes: SimpleChanges): void {
        this.refresh();
    }

    getAggregateSummaryLabel(column: Column) {
        switch (column.summaryAggregation) {
        case 'CALCULATE':
            return 'Calculation';
        case 'SUM':
            return 'Total';
        case 'AVG':
            return 'Average';
        case 'MAX':
            return 'Max';
        case 'MIN':
            return 'Min';
        }
        return '';
    }

    getRowValue(row: any, column: Column) {
        return this.formatValue(row.data[column.accessKey], column);
    }

    formatValue(value, column: Column) {
        return this.columnFormatterService.formatValue(value, column);
    }

    getNumeric(value: string) {
        return this.columnFormatterService.getNumeric(value);
    }

    getFilteredReport() {
        if (!!this.tabReport) {
            const report = new TabReport(this.tabReport);

            if (!!this.selectedPickupLocations && this.selectedPickupLocations.length > 0) {
                const values = [];
                this.selectedPickupLocations.forEach(p => {
                    const filterValue = new FilterValue();
                    filterValue.value = p;
                    values.push(filterValue);
                });

                const locationFilter = new Filter({
                    field: 'PICKUP_LOCATION_ID',
                    operator: 'IN',
                    values,
                    type: 'LONG'
                });
                if (!report.baseFilters) {
                    report.baseFilters = [locationFilter];
                } else {
                    report.baseFilters.push(locationFilter);
                }
            }
            return report;
        }
        return null;
    }
}
